/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DictionaryDto } from '../models/DictionaryDto';
import type { DictionarySearchSportsClubDto } from '../models/DictionarySearchSportsClubDto';
import type { SubscriptionTierDto } from '../models/SubscriptionTierDto';
import type { UserTypeDictionaryDto } from '../models/UserTypeDictionaryDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DictionaryControllerService {
    /**
     * @returns DictionaryDto OK
     * @throws ApiError
     */
    public static getDictionaries(): CancelablePromise<DictionaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dictionaries',
        });
    }
    /**
     * @returns SubscriptionTierDto OK
     * @throws ApiError
     */
    public static getSubscriptionTiers(): CancelablePromise<Array<SubscriptionTierDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dictionaries/subscription-tiers',
        });
    }
    /**
     * @param teamId
     * @returns DictionarySearchSportsClubDto OK
     * @throws ApiError
     */
    public static getYouthTeamsSearchDictionaries(
        teamId: number,
    ): CancelablePromise<DictionarySearchSportsClubDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dictionaries/search/youth-teams/{teamId}',
            path: {
                'teamId': teamId,
            },
        });
    }
    /**
     * @returns DictionarySearchSportsClubDto OK
     * @throws ApiError
     */
    public static getSportsClubSearchDictionaries(): CancelablePromise<DictionarySearchSportsClubDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dictionaries/search/sports-club',
        });
    }
    /**
     * @returns DictionarySearchSportsClubDto OK
     * @throws ApiError
     */
    public static getSeniorTeamsSearchDictionaries(): CancelablePromise<DictionarySearchSportsClubDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dictionaries/search/senior-teams',
        });
    }
    /**
     * @returns UserTypeDictionaryDto OK
     * @throws ApiError
     */
    public static getUserTypesForRegistration(): CancelablePromise<Array<UserTypeDictionaryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dictionaries/register',
        });
    }
    /**
     * @param teamId
     * @param maxDistanceKm
     * @returns any OK
     * @throws ApiError
     */
    /**
     * @param latitude
     * @param longitude
     * @param maxDistanceKm
     * @returns any OK
     * @throws ApiError
     */
    public static getTerritoriesByCoordinates(
        latitude: number,
        longitude: number,
        maxDistanceKm: number,
    ): CancelablePromise<{ voivodeships: Array<string>; counties: Array<string> }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dictionaries/territories-by-coordinates',
            query: {
                'latitude': latitude,
                'longitude': longitude,
                'maxDistanceKm': maxDistanceKm,
            },
        });
    }
    /**
     * @param teamId
     * @param maxDistanceKm
     * @returns any OK
     * @throws ApiError
     */
    public static getTerritoriesByDistance(
        teamId: number,
        maxDistanceKm: number,
    ): CancelablePromise<{ voivodeships: Array<string>; counties: Array<string> }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dictionaries/territories-by-distance',
            query: {
                'teamId': teamId,
                'maxDistanceKm': maxDistanceKm,
            },
        });
    }
}
